import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import ViewDetailsDrawerEquipment from "../../ViewDetailsDrawerEquipment";
import ViewDetailsDrawerFacility from "../../ViewDetailsDrawerFacility";
import ViewDetailsDrawerInHouseOffset from "./ViewDetailsDrawerInHouseOffset";
import ViewDetailsDrawerOffsetCreditPurchase from "./ViewDetailsDrawerOffsetCreditPurchase";

const CarbonOffsetting = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [url, setUrl] = useState("/scope4/in-house-offset-project/inHouseOffsetProjectApprovalList");
  const [approvalUrl, setApprovalUrl] = useState(
    "/scope4/in-house-offset-project/inHouseOffsetProjectApproveOrReject"
  );
  const [Doc, SetDoc] = useState([]);

  const toggleData = [
    {
      title: "In-House Offset Projects",
      url: "/scope4/in-house-offset-project/inHouseOffsetProjectApprovalList",
      approvalUrl: "/scope4/in-house-offset-project/inHouseOffsetProjectApproveOrReject",
    },
    {
      title: "Offset Credit Purchase",
      url: "/scope4/off-set-credit-purchase/offsetCreditPurchaseApprovalList",
      approvalUrl: "/scope4/off-set-credit-purchase/offsetCreditPurchaseApproveOrReject",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Project Name",
      key: "projectName",
    },
    // {
    //   title: "Project Type",
    //   key: "projectType",
    // },
    // {
    //   title: "Verification Status",
    //   key: "verificationStatus",
    // },
    {
      title: "Carbon Sequestered",
      key: "carbonSequesteredAnnually",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Vendor Registry",
      key: "vendorRegistry",
    },
    {
      title: "Project ID/Name",
      key: "projectIdOrName",
    },
    // {
    //   title: "Project Type",
    //   key: "projectType",
    // },
    // {
    //   title: "Credits Purchased",
    //   key: "creditsPurchased",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "updatedAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Project Type": false,
    "Verification Status": false,
  });
  const [limit] = useState(10);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    projectType: [],
    verificationStatus: [],
  });
  const viewheadersEquipment = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "projectName", title: "Project Name" },
    { key: "projectType", title: "Project Type" },
    { key: "projectLocation", title: "Project Location" },
    { key: "verificationStatus", title: "Verification Status" },
    { key: "carbonSequesteredAnnually", title: "Carbon Sequestered Annually (tCO₂e)" },
    { key: "methodologyUsed", title: "Methodology Used" },
    { key: "remarks", title: "Remarks" },
    { key: "editRemarkReason", title: "Edit Remark Reason" },
  ];

  const viewheadersFacility = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "vendorRegistry", title: "Vendor Registry" },
    { key: "projectIdOrName", title: "Project ID/Name" },
    { key: "projectType", title: "Project Type" },
    { key: "creditsPurchased", title: "Credits Purchased (tCO₂e)" },
    { key: "vintageYear", title: "Vintage Year" },
    { key: "appliedScopes", title: "Applied Scopes" },
    { key: "remarks", title: "Remarks" },
    { key: "editRemarkReason", title: "Edit Remark Reason" },
  ];
  const [searchQuery, setSearchQuery] = useState("");
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 15% 15% 15% 16% 8%" : "12% 20% 20% 18% 18% 8%"
  );
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const fetchUniqueValues = async () => {
    try {
      const response = await get(url);
      const data = response.data.data;

      if (selectedOption === "In-House Offset Projects") {
        const uniqueProjectType = [
          ...new Set(
            data.map((el) => el.projectType).filter(Boolean)
          ),
        ];
        const uniqueVerificationStatus = [
          ...new Set(
            data.map((el) => el.verificationStatus).filter(Boolean)
          ),
        ];
        setFilterOptions({
          projectType: uniqueProjectType,
          verificationStatus: uniqueVerificationStatus,
        });
        return {
          projectType: uniqueProjectType,
          verificationStatus: uniqueVerificationStatus,
        };
      } else {
        const uniqueVendorRegistry = [
          ...new Set(
            data.map((el) => el.vendorRegistry).filter(Boolean)
          ),
        ];
        const uniqueProjectType = [
          ...new Set(
            data.map((el) => el.projectType).filter(Boolean)
          ),
        ];
        setFilterOptions({
          vendorRegistry: uniqueVendorRegistry,
          projectType: uniqueProjectType,
        });
        return {
          vendorRegistry: uniqueVendorRegistry,
          projectType: uniqueProjectType,
        };
      }
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();
      const response = await get(`${url}?${queryParams}`);
      setData(response.data.data);
      SetDoc(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Project Type",
      type: "option",
      key: "projectType",
      value: filterOptions.projectType,
    },
    {
      title: "Verification Status",
      type: "option",
      key: "verificationStatus",
      value: filterOptions.verificationStatus,
    },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Vendor Registry",
      type: "option",
      key: "vendorRegistry",
      value: filterOptions.vendorRegistry,
    },
    {
      title: "Project Type",
      type: "option",
      key: "projectType",
      value: filterOptions.projectType,
    },
  ];

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    sortConfig,
    searchQuery,
    filterObj,
    url,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);



  const handleFilterChange = (newFilterObj) => {
    if (selectedOption === "In-House Offset Projects") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    }
  };

  const handleToggle = (option, url, approvalUrl) => {
    setSelectedOption(option);
    setUrl(url);
    setApprovalUrl(approvalUrl);

    SetHeading(toggleData?.[0]?.title === option ? heading : heading2);
    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
        : user?.companyAdmin
        ? "11% 14% 13% 12% 13% 11% 14% 8%"
        : "12% 20% 20% 18% 18% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
    setApprovalUrl(toggleData?.[0].approvalUrl);
  }, []);

  const fetchDataCallback = async () => {
    await fetchData();
  };
  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      <>
        <MessagePopup {...{ snackOpen, setsnackOpen }} />
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSearchQuery,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFilterModalOpen,
            toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Carbon Offsetting"}
        />
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <TableDocument
            data={Doc}
            totalPages={1}
            headers={toggleHeding}
            columnWidth={columnWidth}
            setsnackOpen={setsnackOpen}
            fetchDataCallback={fetchDataCallback}
            apiUrl={approvalUrl}
            viewheaders={
              selectedOption === "In-House Offset Projects"
                ? viewheadersEquipment
                : viewheadersFacility
            }
            viewPage={
              selectedOption === "In-House Offset Projects"
                ? ViewDetailsDrawerInHouseOffset
                : ViewDetailsDrawerOffsetCreditPurchase
            }
          />
        </Box>
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={
            selectedOption === "In-House Offset Projects"
              ? filterData
              : filterData2
          }
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      </>
    </MainDashboardLayout>
  );
};

export default CarbonOffsetting;
